import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";

const PRODUCT_IMAGE_SIZE = "50px";
const PRODUCT_IMAGE_CONTAINER_SIZE = "74px";
const PRODUCT_IMAGE_PADDING = "12px";

export interface ProductInfoProps {
  name: string;
  logoUrl: string;
  shortDescription: string;
}

export const ProductInfo: FC<ProductInfoProps> = ({ name, logoUrl, shortDescription }) => {
  return (
    <View flex={1} justifyContent="flex-start" dataTestId="catalog-product-info" padding={{ top: "S200" }}>
      <Row gridGap="S300">
        <View
          display="flex"
          height={PRODUCT_IMAGE_CONTAINER_SIZE}
          width={PRODUCT_IMAGE_CONTAINER_SIZE}
          padding={PRODUCT_IMAGE_PADDING}
          alignItems="center"
          justifyContent="center"
          className="search-result-img-wrapper"
        >
          <img
            alt={name}
            src={logoUrl?.trim() !== "" ? logoUrl : ""}
            data-testid="catalog-item-url"
            style={{
              width: PRODUCT_IMAGE_SIZE,
              height: PRODUCT_IMAGE_SIZE,
              objectFit: "contain",
            }}
          />
        </View>

        <Col gridGap="S200" flex={1}>
          <Row alignItems="center" gridGap="S200" dataTestId="catalog-product-title" flexWrap="wrap">
            <Text fontSize="T200" fontWeight="bold" color="neutral90" lineHeight="24px" hyphens="initial">
              {name}
            </Text>
          </Row>
          <Text
            fontSize="T100"
            fontWeight="regular"
            color="neutral90"
            lineHeight="24px"
            className="product-short-description"
            dataTestId="catalog-product-short-description"
          >
            {shortDescription}
          </Text>
        </Col>
      </Row>
    </View>
  );
};
